import gsap from "gsap";
import { _cursorBubble } from "../utils/_cursorBubble";
import { _section } from "../utils/_section";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";
import { _event } from "../utils/_event";
import { _parallax } from "../utils/_parallax";

class OurLeaders extends MainClass {
    cursor: _cursorBubble | null;

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.cursor = null;

        this.init();
    }

    init() {
        const _updateCursor = (target?: HTMLElement) => {
            if (!this.cursor) return;

            gsap.to(this.cursor.el.bg, {
                duration: 0.3,
                opacity: target ? 1 : 0,
                width: target ? 104 : 0,
                height: target ? 104 : 0,
                scale: target ? 1 : 0,
            });

            gsap.to(this.cursor.el.text, {
                duration: 0.3,
                opacity: target ? 1 : 0,
                width: target ? 104 : 0,
                height: target ? 104 : 0,
                x: "-50%",
                y: "-50%",
                scale: target ? 1 : 0,
            });
        };

        if (!_section.isMobile())
            this.cursor = new _cursorBubble({
                target: this.selector,
                events: {
                    init: (instance, event) => {
                        const _icon = this.selector.querySelector(".js-cursor-icon");
                        if (_icon) {
                            instance.el.text.innerHTML = _icon.innerHTML;
                        }
                    },
                    mouseenter: (instance, event) => {
                        // show the cursorBubble
                        _updateCursor();
                    },
                    mouseleave: (instance, event) => {
                        // hide the cursorBubble
                        _updateCursor();
                    },
                    mousemove: (instance, event) => {
                        const _anchor = event.target?.closest("a") as HTMLElement;
                        const _avatar = _anchor ? _anchor.querySelector(".avatar") : null;
                        _updateCursor(_anchor);

                        instance.followMouse = _anchor && event.target.classList.contains("avatar") ? false : true;

                        if (_anchor && _avatar && !instance.followMouse) {
                            const _avatarRect = _avatar.getBoundingClientRect();

                            const _avatarOffset = {
                                x: ((event.clientX - _avatarRect.left) / _avatarRect.width) * 20,
                                y: ((event.clientY - _avatarRect.top) / _avatarRect.height) * 20,
                            };

                            gsap.to(instance.el.main, {
                                duration: 0.3,
                                x: _avatarRect.left - instance.el.main.offsetWidth * 0.5 + _avatarOffset.x,
                                y:
                                    _anchor.getBoundingClientRect().top -
                                    instance.el.main.offsetHeight * 0.5 +
                                    _avatarOffset.y,
                            });
                        }
                    },
                    mousedown: (instance, event) => {},
                },
            });

        _event.resize(() => {
            const _offset = _parallax.getOffset(this.selector);

            this.selector.style.setProperty("--left", `${_offset.left * -1}px`);
            this.selector.style.setProperty("--width", `${_event.width()}px`);
        });
    }
}

export default OurLeaders;
